import { checkMyPwdStatus, modifyPassword, getUserByUid, loginFromPlatformToken } from '@/api/user'

function resetState() {
  return {
    userByUid: {},
    existsOldPwd: false
  }
}

const state = resetState()

const mutations = {
  resetState(state) {
    const initState = resetState()
    for (const key in initState) {
      state[key] = initState[key]
    }
  },
  setUser(state, user) {
    state.userByUid = { ...state.userByUid, [user.uid]: user }
  },
  setMyPwdStatus(state, existsOldPwd) {
    state.existsOldPwd = existsOldPwd
  }
}

const actions = {
  async fetchUser({ commit, state }, { uid, force }) {
    if (!force && state.userByUid[uid]) {
      return state.userByUid[uid]
    }
    const data = await getUserByUid(uid)
    commit('setUser', data.userInfo)
    return data.userInfo
  },
  async loginFromPlatformToken(_, platformToken) {
    const resData = await loginFromPlatformToken(platformToken)
    const { info = {}, token } = resData || {}
    return { ...info, token }
  },
  async fetchMyPwdStatus({ commit, state }) {
    if (state.existsOldPwd) {
      return true
    }
    const { userInfo } = await checkMyPwdStatus()
    commit('setMyPwdStatus', userInfo.passwordExist)
  },
  async modifyPassword({ dispatch }, data) {
    await modifyPassword(data)
    setTimeout(async () => {
      await dispatch('mqttLogout', null, { root: true })
      await dispatch('logoutReset', null, { root: true })
    }, 300)
  }
}

const userModule = {
  namespaced: true,
  state,
  mutations,
  actions
}

export default userModule
